import { PrinterOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactToPrint from 'react-to-print';
import styled from 'styled-components';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const PrintLabelModal = ({ visible, setVisible }) => {
  const { t } = useTranslation();

  const printRef = React.createRef<any>();

  return (
    <ModalWrapper
      title={t('orders.reviewPrint')}
      onCancel={() => setVisible(false)}
      destroyOnClose
      open={visible}
      width="23cm"
      footer={[<PrintButton printRef={printRef} />]}
    >
      <div className="d-flex column center text-align:right;">
        <div ref={printRef} className="print-container"></div>
      </div>
    </ModalWrapper>
  );
};

interface PrintButtonProps {
  printRef: React.RefObject<HTMLDivElement>;
}

const PrintButton: React.FC<PrintButtonProps> = ({ printRef }) => (
  <ReactToPrint
    trigger={() => (
      <Button type="primary" className="no-print" icon={<PrinterOutlined />}>
        Print
      </Button>
    )}
    content={() => printRef.current}
  />
);

const ModalWrapper = styled(Modal)`
  .ant-modal-body {
    max-height: 60vh;
    overflow: auto;
  }
  @media print {
    section {
      page-break-after: always;
      margin-top: 0px;
    }
    @page {
      size: 10cm 15cm;
      margin: 0;
    }
    @page {
      size: 10cm 15cm;
      margin: 0;
    }
  }
`;

export default PrintLabelModal;
